import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireOrgFeature } from '../lib/orgFeatureGate';

// SIL-249 T13: Financials section layout. Sibling screens (depreciation
// schedule, capitalization policy, disposition scenarios — T14-T17) mount
// as siblings under this same layout on separate branches; this route file
// stays a bare Outlet so those merges never touch it.
//
// SIL-1108: `orgFeature: 'finance'` (customerNav.ts) is business-only. A
// direct hit on e.g. `/financials` fired the setup/summary redirect logic
// (financials/index.tsx's own `beforeLoad`) and its business-only API calls
// (`GET /api/client/financials/setup`, `.../summary`) before the root
// `OrgFeatureGate`'s (__root.tsx) `useEffect`-based redirect ever landed —
// same class of bug as SIL-1102's /market-intelligence fix. Gating here, in
// the layout's own `beforeLoad`, runs before every child route's own
// `beforeLoad`/loader/component (setup, book-vs-fmv, opportunity,
// asset-financials, depreciation, policy, scenarios, triage), so one check
// covers the whole section.
export const Route = createFileRoute('/financials')({
  beforeLoad: () => requireOrgFeature('finance'),
  component: () => <Outlet />,
});
